import React from 'react';
import { ArrowRightIcon, WorkflowIcon } from 'lucide-react';
import type { BuilderTemplateId } from '../../types/builder';
import { builderTemplateHref } from '../../data/customBuilder';
import { CtaButton } from '../ui/CtaButton';
import { Reveal } from '../ui/Reveal';

/** "Customize this workflow" link into the DGPT Builder with a matching template. */
export function CustomizeWorkflowBand({
  template,
  placement
}: {
  template: BuilderTemplateId;
  placement: string;
}) {
  return <section aria-labelledby={`customize-${placement}-heading`} className="border-b border-hairline-soft bg-ink" data-id="element-1315" data-mp="35q3l6h1uiqpi">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-14 sm:px-6 lg:px-8" data-id="element-1316" data-mp="3jq4o021o887m">
        <Reveal className="flex flex-col gap-5 rounded-2xl border border-hairline bg-panel p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8" data-id="element-1317" data-mp="3eqs0df2z6x3z">
          <div className="flex gap-4" data-id="element-1318" data-mp="yxt0fm2cc0v4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-violet-soft text-lime" data-id="element-1319" data-mp="u09myodgvs48">
              <WorkflowIcon className="h-5 w-5" aria-hidden="true" data-id="element-1320" data-mp="2g38fist2ugh1" />
            </span>
            <div data-id="element-1321" data-mp="2l1jn0wvwgew3">
              <h2 id={`customize-${placement}-heading`} className="text-xl font-semibold tracking-[-0.015em] text-text-primary" data-id="element-1322" data-mp="2l10hygrclkzh">
                Customize this workflow
              </h2>
              <p className="mt-1 text-sm text-text-secondary" data-id="element-1323" data-mp="2v0izkqjscuod">Open it in the DGPT Custom Workflow Builder and shape the steps, rules and approvals to your process.</p>
            </div>
          </div>
          <CtaButton href={builderTemplateHref(template)} size="lg" event="builder_cta_click" eventParams={{
          placement: `${placement}_customize`,
          template
        }} className="w-full shrink-0 sm:w-auto" data-id="element-1324" data-mp="22ashk6f198mz">
            Customize with DGPT Builder
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1325" data-mp="1emj2dncbrj4t" />
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}